import { render, staticRenderFns } from "./InvoiceVAT.vue?vue&type=template&id=777f1fa5"
import script from "./InvoiceVAT.vue?vue&type=script&lang=js"
export * from "./InvoiceVAT.vue?vue&type=script&lang=js"
import style0 from "./InvoiceVAT.vue?vue&type=style&index=0&id=777f1fa5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports